import { GridSortItem } from "@mui/x-data-grid";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { useRef } from "react";
import { AppointmentControllerApi } from "../services";
import { AppointmentDetails } from "../types/appointment-types";
import {
  DGT_Pagination,
  asPaginatedContent,
  getConfigObject,
  getPageIndexWhileSearch,
  getPageSize,
  getXtenantId,
  useBaseContent,
} from "../utils/utils";

interface UseAppointmentsBillingEncounterProps {
  pagination: DGT_Pagination;
  gridSorting?: GridSortItem[];
  patientUuid?: Array<string>;
  providerUuid?: Array<string>;
  searchKey?: string;
  appointmentType?: string;
  encounterDate?: string;
  searchString?: string;
}

/**
 *
 * @author Atish Bagate
 */

export function useAppointmentsBillingEncounter({
  gridSorting,
  appointmentType,
  encounterDate,
  pagination,
  searchKey,
  patientUuid,
  providerUuid,
  searchString,
}: UseAppointmentsBillingEncounterProps): useBaseContent<AppointmentDetails> {
  const prevPage = useRef<number>(pagination.page);

  const pageIndex = getPageIndexWhileSearch({
    pagination,
    searchKey,
    prevPage,
  });
  const pageSize = getPageSize(searchKey, pagination);

  const sortData = gridSorting?.[0];

  return useQuery({
    queryKey: [
      "appointment-billing-encounter",
      pageIndex,
      pageSize,
      appointmentType,
      patientUuid,
      providerUuid,
      encounterDate,
      searchString,
      gridSorting,
    ],
    placeholderData: keepPreviousData,
    refetchOnWindowFocus: false,
    queryFn: async () =>
      new AppointmentControllerApi(getConfigObject())
        .getAllAppointments1(
          pageIndex, //page
          pageSize, //size
          sortData?.field, // sortBy
          sortData?.sort ?? undefined, // sortDirection
          patientUuid, //patientUuid
          providerUuid, //providerUuid  s
          appointmentType, //appointmentType
          encounterDate, //encounterDate
          searchString, //searchString
          getXtenantId() //xTENANTID
        )
        .then((it) => asPaginatedContent<AppointmentDetails>(it?.data)),
  });
}
